/* eslint-disable */
import { DateTime } from 'luxon';

/* Get the current instant */
const now = DateTime.now();

export const notifications = [
    {
        id: 'b1a9fbc1-30a4-4a68-b3d1-9d8a32ac53a2',
        icon: 'heroicons_mini:calendar-days',
        title: 'Booking Updated - Badminton',
        description:
            'Venue: <strong>Al Banush Club</strong><br/>Court: <em>Basket Ball</em><br/>Date: <strong>09 Oct 2025</strong><br/>Time: <strong>06:00 - 06:30 AM</strong><br/>Status: <span style="color:#ff4081;">Tentative</span><br/>Payment: <strong>AED 6</strong>',
        time: now.minus({ minute: 25 }).toISO(), // 25 minutes ago
        read: false,
    },
    {
        id: '2f9c8b53-24d9-4fa3-8f67-31d1c784b321',
        icon: 'heroicons_mini:calendar-days',
        title: 'New Booking - Tennis',
        description:
            'Venue: <strong>Marina Sports Complex</strong><br/>Court: <em>Tennis Court A</em><br/>Date: <strong>10 Oct 2025</strong><br/>Time: <strong>07:00 - 07:45 AM</strong><br/>Status: <span style="color:#ff9800;">Confirmed</span><br/>Payment: <strong>AED 12</strong>',
        time: now.minus({ hour: 1 }).toISO(), // 1 hour ago
        read: false,
        link: '/bookings/details',
        useRouter: true,
    },
    {
        id: '3eab4f3a-56d1-4c21-8457-7a9b83a70d12',
        icon: 'heroicons_mini:clock',
        title: 'Booking Reminder - Football',
        description:
            'Venue: <strong>Al Wasl Stadium</strong><br/>Court: <em>Main Field</em><br/>Date: <strong>09 Oct 2025</strong><br/>Time: <strong>08:00 - 09:00 PM</strong><br/>Status: <span style="color:#4caf50;">Confirmed</span><br/>Payment: <strong>AED 20</strong>',
        time: now.minus({ hour: 3 }).toISO(),
        read: false,
    },
    {
        id: '7c3f1b2a-223d-45b9-a721-941f51c1cf1b',
        icon: 'heroicons_mini:arrow-path',
        title: 'Booking Updated - Swimming',
        description:
            'Venue: <strong>Dubai Sports Club</strong><br/>Court: <em>Lane 2</em><br/>Date: <strong>08 Oct 2025</strong><br/>Time: <strong>05:00 - 05:45 PM</strong><br/>Status: <span style="color:#03a9f4;">Rescheduled</span><br/>Payment: <strong>AED 10</strong>',
        time: now.minus({ hour: 6 }).toISO(),
        read: true,
        link: '/bookings/details',
        useRouter: true,
    },
    {
        id: 'd2a91461-ec8c-482d-bef1-51e640d16a7b',
        icon: 'heroicons_mini:check-circle',
        title: 'Booking Confirmed - Cricket',
        description:
            'Venue: <strong>Sharjah Cricket Ground</strong><br/>Court: <em>Pitch 1</em><br/>Date: <strong>11 Oct 2025</strong><br/>Time: <strong>09:00 AM - 12:00 PM</strong><br/>Status: <span style="color:#4caf50;">Confirmed</span><br/>Payment: <strong>AED 50</strong>',
        time: now.minus({ day: 1 }).toISO(),
        read: true,
        link: '/bookings/details',
        useRouter: true,
    },
    {
        id: 'e6b6a2de-b87a-4c57-8a2a-d86c6a8e1ef7',
        icon: 'heroicons_mini:calendar-days',
        title: 'Booking Cancelled - Squash',
        description:
            'Venue: <strong>Fitness Hub</strong><br/>Court: <em>Squash Room 3</em><br/>Date: <strong>08 Oct 2025</strong><br/>Time: <strong>06:30 - 07:00 PM</strong><br/>Status: <span style="color:#f44336;">Cancelled</span><br/>Payment: <strong>Refund AED 8</strong>',
        time: now.minus({ day: 2 }).toISO(),
        read: true,
        link: '/bookings/details',
        useRouter: true,
    },
];
